export default __webpack_public_path__ + "e1b30879c4c39bc8229420a2b9069eb5.svg";